import styled from '@emotion/styled';
import { themeVariables } from '../../themeVariables';

export type ButtonComponentStyledPropsType = {
  fullWidth?: boolean;
  justifyContent?: string;
};

export const ButtonComponentStyled = styled.div<ButtonComponentStyledPropsType>`
  display: flex;
  align-items: center;
  width: ${props => (props.fullWidth ? '100%' : 'initial')};
  justify-content: ${props =>
    props.justifyContent ? props.justifyContent : 'initial'};

  .MuiButton-root {
    text-transform: none;
    font-weight: 600;
  }
  
  .MuiButton-contained:hover{
    text-decoration: underline !important;
    background: ${themeVariables.colors.secondary} !important;
  } 

  .MuiButton-outlined:hover{
    text-decoration: underline !important;
    background: '#FFF' !important;
  } 

  .MuiButton-contained {
    padding: 0.7rem 1rem;
    border-radius: 0;
    text-transform: uppercase;
    background: ${themeVariables.colors.secondary};
  }

  .MuiButton-outlined {
    border-radius: 0px;
    border: 0.1rem solid ${themeVariables.colors.primary};
  }

  .MuiButton-text {
    text-decoration: underline;
    text-transform: uppercase;
    color: ${themeVariables.colors.secondary};
  }
`;
